import Modal from '../modal/modal.ts'
import { Nullable } from '../../types/common.ts'

class PasswordModal extends Modal {
  passwordInput: Nullable<HTMLInputElement>

  constructor() {
    super()

    this.passwordInput = this.querySelector('[password-modal-input]')
  }

  show(): void {
    super.show()

    if (this.passwordInput) {
      this.passwordInput.focus()
    }
  }
}

export default PasswordModal
